module.exports = __webpack_public_path__ + "static/Colleen.1cca1b47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Colleen.jpg
// module id = 1292
// module chunks = 137408898365125